var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 67,
    viewBox: "0 0 77 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3869 42.579C46.2899 42.579 53.2805 38.9836 57.5303 33.4789C53.2843 27.9703 46.2899 24.3749 38.3869 24.3749C30.4839 24.3749 23.4895 27.9703 19.2435 33.4789C23.4895 38.9875 30.4801 42.579 38.3869 42.579Z",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1389 27.3736C46.5978 28.9865 47.487 31.1268 47.487 33.475C47.487 38.5024 43.4105 42.5752 38.3869 42.5752C33.3633 42.5752 29.2868 38.4986 29.2868 33.475C29.2868 31.1192 30.1798 28.9711 31.6503 27.3544",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3869 35.5807L35.777 37.3245L36.6277 34.3027L34.164 32.3587L37.2975 32.2355L38.3869 29.2906L39.4724 32.2355L42.6098 32.3587L40.1461 34.3027L40.9968 37.3245L38.3869 35.5807Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2108 33.3094C53.0264 29.3021 46.1359 26.6884 38.3523 26.6884C30.5686 26.6884 23.6781 29.3021 19.4899 33.3094",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4494 20.2521C39.4494 20.8603 38.9566 21.353 38.3484 21.353C37.7402 21.353 37.2475 20.8603 37.2475 20.2521C37.2475 19.6439 37.7402 19.1511 38.3484 19.1511C38.9566 19.1511 39.4494 19.6439 39.4494 20.2521Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.861 34.5836C61.2527 34.5836 60.76 34.0909 60.76 33.4827C60.76 32.8744 61.2527 32.3817 61.861 32.3817C62.4692 32.3817 62.9619 32.8744 62.9619 33.4827C62.9619 34.0909 62.4692 34.5836 61.861 34.5836Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1526 24.0515C51.7215 24.4827 51.0247 24.4827 50.5974 24.0515C50.1663 23.6204 50.1663 22.9236 50.5974 22.4963C51.0286 22.0652 51.7253 22.0652 52.1526 22.4963C52.5837 22.9275 52.5837 23.6242 52.1526 24.0515Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3523 7.36401V17.9885",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5825 33.4442H76.3157",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5842 15.4556L52.934 21.6109",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.568 21.611L56.4294 27.4737",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4071 11.6177L44.4999 20.968",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1932 2.83706C39.8843 3.32594 38.8411 4.3653 38.3484 5.67027C37.8557 4.36145 36.8163 3.32594 35.5075 2.83706C36.8163 2.34433 37.8557 1.30882 38.3484 0C38.8411 1.30882 39.8843 2.34433 41.1932 2.83706Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4878 46.6979C39.4878 47.3061 38.9951 47.7988 38.3869 47.7988C37.7787 47.7988 37.286 47.3061 37.286 46.6979C37.286 46.0897 37.7787 45.5969 38.3869 45.5969C38.9951 45.5969 39.4878 46.0897 39.4878 46.6979Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4926 48.0991C40.8313 48.5418 41.0353 49.0923 41.0353 49.689C41.0353 51.1441 39.8343 52.3258 38.3523 52.3258C36.8702 52.3258 35.6692 51.1441 35.6692 49.689C35.6692 49.0923 35.8693 48.5418 36.212 48.0991C36.212 48.1299 36.212 48.1569 36.212 48.1877C36.212 49.3502 37.1705 50.2933 38.3561 50.2933C39.5417 50.2933 40.5003 49.3502 40.5003 48.1877C40.5003 48.1569 40.5003 48.1299 40.5003 48.0991H40.4926Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3869 54.774V66.6035",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5842 38.5293V46.7595",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.97 50.2125C58.331 50.4512 57.8229 50.9555 57.5842 51.5945C57.3455 50.9555 56.8374 50.4512 56.1984 50.2125C56.8374 49.9739 57.3417 49.4657 57.5842 48.8306C57.8229 49.4696 58.331 49.9739 58.97 50.2125Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8446 42.0054V55.2398",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1158 44.6654V57.1069",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2167 60.6869C46.2167 61.2951 45.724 61.7878 45.1158 61.7878C44.5076 61.7878 44.0148 61.2951 44.0148 60.6869C44.0148 60.0787 44.5076 59.5859 45.1158 59.5859C45.724 59.5859 46.2167 60.0787 46.2167 60.6869Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8551 34.5836C15.4633 34.5836 15.956 34.0909 15.956 33.4827C15.956 32.8744 15.4633 32.3817 14.8551 32.3817C14.2469 32.3817 13.7542 32.8744 13.7542 33.4827C13.7542 34.0909 14.2469 34.5836 14.8551 34.5836Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5635 24.0515C24.9946 24.4827 25.6914 24.4827 26.1186 24.0515C26.5498 23.6204 26.5498 22.9236 26.1186 22.4963C25.6875 22.0652 24.9907 22.0652 24.5635 22.4963C24.1323 22.9275 24.1323 23.6242 24.5635 24.0515Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1335 33.4442H0.400345",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1319 15.4556L23.782 21.6109",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1442 21.611L20.2828 27.4737",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.309 11.6177L32.2162 20.968",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1319 38.5293V46.7595",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.746 50.2125C18.3851 50.4512 18.8932 50.9555 19.1319 51.5945C19.3705 50.9555 19.8787 50.4512 20.5177 50.2125C19.8787 49.9739 19.3744 49.4657 19.1319 48.8306C18.8932 49.4696 18.3851 49.9739 17.746 50.2125Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8714 42.0054V55.2398",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6003 44.6654V57.1069",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4993 60.6869C30.4993 61.2951 30.9921 61.7878 31.6003 61.7878C32.2085 61.7878 32.7012 61.2951 32.7012 60.6869C32.7012 60.0787 32.2085 59.5859 31.6003 59.5859C30.9921 59.5859 30.4993 60.0787 30.4993 60.6869Z",
    fill: "#FFCD83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.7161,
    height: 67,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.8377f9b364142b3cf74cc83a73e9b22f.svg";
export { ForwardRef as ReactComponent };